export class ProductSummary {
    companyName: string;
    productName: string;
    totalVoucherCount: number;
    unassignedVoucherCount: number;
    unexportedVoucherCount: number;
    redeemedVoucherCount: number;

    totalProductKeyCount: number;
    assignedProductKeyCount: number;
    unassignedProductKeyCount: number;
    redeemableProductKeyCount: number;

    /* Keys that exist and are unassigned, but that validateAndAssignVoucher cannot
       see because their deletedDate field is missing rather than null. */
    invisibleProductKeyCount: number;

    /* How many outstanding vouchers could not be redeemed with the keys on hand. */
    productKeyShortfall: number;

    constructor(companyName: string, productName: string, totalVoucherCount: number, unassignedVoucherCount: number, unexportedVoucherCount: number, redeemedVoucherCount: number,
        totalProductKeyCount: number, unassignedProductKeyCount: number, redeemableProductKeyCount: number) {
        this.companyName = companyName;
        this.productName = productName;

        this.totalVoucherCount = totalVoucherCount;
        this.unassignedVoucherCount = unassignedVoucherCount;
        this.unexportedVoucherCount = unexportedVoucherCount;
        this.redeemedVoucherCount = redeemedVoucherCount;

        this.totalProductKeyCount = totalProductKeyCount;
        this.assignedProductKeyCount = totalProductKeyCount - unassignedProductKeyCount;
        this.unassignedProductKeyCount = unassignedProductKeyCount;
        this.redeemableProductKeyCount = redeemableProductKeyCount;

        this.invisibleProductKeyCount = unassignedProductKeyCount - redeemableProductKeyCount;
        this.productKeyShortfall = unassignedVoucherCount - redeemableProductKeyCount;
    }
}
